import { useState } from "react";
import "./TooltipUI.css";

const TooltipUIViewOnly2 = ({ children, text }) => {
  const [show, setShow] = useState(false);

  return (
    <div
      className="tooltip-container"
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      {children}
      {show && text && (
        <div className="tooltipviewonly2">
          {text}
          <span className="tooltip-arrowviewonly2" />
        </div>
      )}
    </div>
  );
};

export default TooltipUIViewOnly2;